<template>
  <el-row class="bread">
    <el-col :span="11" class="left-box">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <template v-for="bread in breadList" >
          <el-breadcrumb-item :key="bread.url" :to="{ path: bread.url }" v-if="bread.url">{{bread.name}}</el-breadcrumb-item>
          <el-breadcrumb-item :key="bread.name" v-else>{{bread.name}}</el-breadcrumb-item>
        </template>
        <slot name="v-left"></slot>
      </el-breadcrumb>
    </el-col>
    <el-col :span="13" align="right" class="right-box">
      <slot name="v-right"></slot>
    </el-col>
    <slot></slot>
  </el-row>
</template>

<script>
export default {
  name: 'Bread',

  data() {
    return {};
  },

  props: ['breadList'],
};
</script>

<style lang="scss">
  .bread {
    height: 40px;
    padding: 10px 25px;
    background: #304056;
    border-bottom: 1px solid #1d2d3d;
    border-left: 1px solid #1e2d3d;
    .el-breadcrumb {
      line-height: 20px;
      font-size: 14px;
      .el-breadcrumb__item:not(:last-child) {
        .el-breadcrumb__inner {
          color: #bfcbd9;
          font-weight: 400;
        }
      }
      .el-breadcrumb__item:last-child {
        .el-breadcrumb__inner {
          color: #bfcbd9;
        }
      }
    }
    .right-box {
      font-size: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/v-bread.vue